import { NotificationsPanel } from '@/app-shell/layout/Navigation/notifications/notifications-panel';

/**
 * Notifications panel content for the mobile sidebar sheet.
 * Wraps the same `NotificationsPanel` used inside the desktop popover so
 * the mobile path stays in lockstep with desktop content (cards, empty
 * states, etc.).
 *
 * The mobile panel host (`panel-mobile.tsx`) wraps `activePanelContent`
 * in `<div class="flex-1 overflow-y-auto">` — a block element, not a
 * flex column. `NotificationsPanel`'s `flex-1 min-h-0` height chain
 * collapses to 0 inside a block parent (no cards, no empty state), so
 * we provide the missing flex frame ourselves. Mirrors what the popover
 * (`PopoverContent`) supplies on its surface.
 */
export const NotificationsPanelContent = () => (
  <div className="flex h-full flex-col">
    <NotificationsPanel />
  </div>
);
